/**
 * Rounds parameter {@link value} to the specified number of {@link decimals}.
 * @param value Value to round
 * @param decimals Number of decimals
 * @returns Rounded `value`
 */
export function round(value, decimals) {
  return Math.round((value + Number.EPSILON) * 10 ** decimals) / 10 ** decimals;
}
//# sourceMappingURL=round.js.map